<template>
  <div class="sidebar-left page-role">
    <div class="sidebar">
      <left-slidebar
          :is-show-me="isShowEdit"
          :data="editData"
          @hide-edit="$emit('update:is-show-edit', false)"
          @reload-list="reloadList"
          @update-current="updateCurrent"
      />

      <!-- Sidebar Content -->
      <div class="sidebar-content" :class="{ show: isShowMe }">
        <span
            class="sidebar-close-icon"
            @click="$emit('update:isShowMe', false)"
        >
          <feather-icon icon="XIcon" size="16"/>
        </span>

        <!-- Thêm mới -->
        <div class="chat-fixed-search cs-add-role">
          <div class="d-flex align-items-center w-100">
            <div class="sidebar-profile-toggle">
              <b-button
                  size="md"
                  variant="primary"
                  class="cursor-pointer badge-minimal avatar-border-2"
                  @click="$emit('show-left-slidebar', {})"
              >
                <feather-icon icon="PlusIcon"/>
                Thêm mới
              </b-button>
            </div>
            <!-- Search -->
            <!-- <b-input-group class="input-group-merge ml-1 w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" class="text-muted" />
              </b-input-group-prepend>
              <b-form-input v-model="searchQuery" placeholder="Search..." />
            </b-input-group> -->
          </div>
        </div>

        <!-- ScrollArea: Chat -->
        <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="chat-user-list-wrapper list-group scroll-area cs-list-role"
        >
          <h4 class="chat-list-title list-role-title">Quyền</h4>

          <ul class="chat-users-list chat-list list-role media-list ">
            <left-item
                v-for="item in filteredData"
                :key="item.id"
                :data="item"
                :class="{
                active: curData != null ? curData.id == item.id : false,
              }"
                @click="$emit('show-detail-data', item)"
                @show-edit="showEdit"
                @reload-list="reloadList"
            />
          </ul>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BAvatar,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ref, computed } from '@vue/composition-api'
import LeftItem from './LeftItem.vue'
import LeftSlidebar from './LeftSlidebar.vue'

export default {
  components: {
    // BSV
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,

    // 3rd party
    VuePerfectScrollbar,

    LeftItem,
    LeftSlidebar,
  },
  props: {
    listData: {
      type: Array,
      required: true,
    },
    curData: {
      type: Object,
      default: true,
    },
    isShowMe: {
      type: Boolean,
      default: true,
    },
    isShowEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    curData(val) {
      this.editData = JSON.parse(JSON.stringify(val))
    },
  },
  methods: {
    showEdit(data) {
      this.$emit('show-left-slidebar', data)
    },
    reloadList() {
      this.$emit('reload-list')
    },
    updateCurrent(newItem) {
      this.$emit('update-current', newItem)
    },
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // const searchQuery = ref("");
    const editData = ref({})
    // const searchFilterFunction = function (ele) {
    //   return ele
    //     ? ele.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    //         ele.code.toLowerCase().includes(searchQuery.value.toLowerCase())
    //     : false;
    // };
    const filteredData = computed(() => props.listData)

    return {
      // searchQuery,
      filteredData,
      perfectScrollbarSettings,
      editData,
    }
  },
}
</script>
